import { onMounted, onUnmounted } from "vue";

/**
 * Listens for postMessage callbacks from the GitHub App install popup.
 * Used by both GithubConnection.vue and GithubAccounts.vue.
 *
 * @param {Object} options
 * @param {() => void} options.onSuccess - Called when installation succeeds
 * @param {(reason: string) => void} options.onError - Called when installation fails
 */
export function useGithubCallback({ onSuccess, onError }) {
  const handleMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type !== "github_app_callback") return;

    if (event.data.status === "success") {
      onSuccess();
    } else {
      onError(event.data.reason || "GitHub App installation failed");
    }
  };

  onMounted(() => window.addEventListener("message", handleMessage));
  onUnmounted(() => window.removeEventListener("message", handleMessage));
}
